import Dispatcher from "../../../flux/dispatcher/dispatcher";
import { EventEmitter } from "events";
import Constant from "../Constants";
import assign from "object-assign";

const RESPONSE_CHANGE_EVENT = "globalResponse";

let response = {};

function parseResponse(resp) {
  let newResponse = {
    status: resp.status,
    blockedSpamDomain: resp.blockedSpamDomains,
    blockedPublicEmail: resp.blockedPublicEmailDomains,
    blockedTopLevelDomains: resp.blockedTopLevelDomains,
    blockedDomainErrorMessages: resp.blockedDomainErrorMessages,
  };
  response = newResponse;
}

const GetBlockedPublicEmailDomainStore = assign({}, EventEmitter.prototype, {
  emitChangeEvent: function (event) {
    this.emit(event);
  },
  bind: function (callback) {
    this.on(RESPONSE_CHANGE_EVENT, callback);
  },
  unbind: function (callback) {
    this.removeListener(RESPONSE_CHANGE_EVENT, callback);
  },
  getResponse: function () {
    return response;
  },
});

Dispatcher.register(function (action) {
  switch (action.actionType) {
    case Constant.GET_BLOCKED_PUBLIC_EMAIL_DOMAIN:
      const resp = action.data;
      parseResponse(resp);
      GetBlockedPublicEmailDomainStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
      break;
    default:
  }
});

export default GetBlockedPublicEmailDomainStore;
